// =============================================================
// THEORIC ANALYTICS — Custom Event Tracking for GA4
// Adicionar em theme.liquid antes de </body>
// =============================================================

(function () {
    'use strict';

    // ---- CONFIG ----
    const ZONE_MAP = {
        '/': [
            { selector: '.hero-banner, .slideshow, [data-section-type="slideshow"]', zone: 'hero_banner' },
            { selector: '.quiz-cta, [href*="quiz"], .quiz-banner', zone: 'quiz_cta' },
            { selector: '.featured-products, .product-grid-featured', zone: 'produtos_destaque' },
            { selector: '.testimonials, .reviews-section', zone: 'depoimentos' },
            { selector: '.instagram-feed, .social-feed', zone: 'instagram_feed' },
            { selector: 'footer, .site-footer', zone: 'footer' }
        ],
        '/products/': [
            { selector: '.product-gallery, .product-images, .product__media', zone: 'galeria_imagens' },
            { selector: '.product-title, .product__title', zone: 'titulo_preco' },
            { selector: '.product-form__submit, .add-to-cart, [name="add"]', zone: 'add_to_cart_btn' },
            { selector: '.product-description, .product__description', zone: 'descricao' },
            { selector: '.product-ingredients, .ingredients-section', zone: 'ingredientes' },
            { selector: '.product-reviews, .reviews, .spr-container', zone: 'reviews' },
            { selector: '.related-products, .product-recommendations', zone: 'relacionados' }
        ],
        '/collections/': [
            { selector: '.collection-filters, .facets', zone: 'filtros' },
            { selector: '.product-card:nth-child(1)', zone: 'produto_1' },
            { selector: '.product-card:nth-child(2)', zone: 'produto_2' },
            { selector: '.product-card:nth-child(3)', zone: 'produto_3' },
            { selector: '.product-card:nth-child(4)', zone: 'produto_4' },
            { selector: '.product-card:nth-child(5)', zone: 'produto_5' },
            { selector: '.product-card:nth-child(6)', zone: 'produto_6' }
        ],
        '/pages/quiz': [
            { selector: '.quiz-question, .quiz-step.active', zone: 'pergunta_ativa' },
            { selector: '.quiz-progress', zone: 'barra_progresso' },
            { selector: '.quiz-result', zone: 'resultado' },
            { selector: '.quiz-cta-buy, .quiz-result a[href*="cart"]', zone: 'cta_comprar' }
        ]
    };

    // ---- UTILS ----
    function getPageType() {
        const path = window.location.pathname;
        if (path === '/') return '/';
        if (path.startsWith('/products/')) return '/products/';
        if (path.startsWith('/collections/')) return '/collections/';
        if (path.startsWith('/pages/quiz')) return '/pages/quiz';
        return path;
    }

    function sendGA4Event(eventName, params) {
        if (typeof gtag === 'function') {
            gtag('event', eventName, params);
        }
    }

    // ---- ZONE CLICK TRACKING ----
    function initZoneTracking() {
        const pageType = getPageType();
        const zones = ZONE_MAP[pageType];
        if (!zones) return;

        zones.forEach(function (zoneDef) {
            document.querySelectorAll(zoneDef.selector).forEach(function (el) {
                el.addEventListener('click', function (e) {
                    sendGA4Event('zone_click', {
                        page_path: window.location.pathname,
                        page_type: pageType,
                        zone_name: zoneDef.zone,
                        element_tag: e.target.tagName.toLowerCase(),
                        // Posição relativa do clique na zona (0-100%)
                        click_x_pct: Math.round((e.offsetX / el.offsetWidth) * 100),
                        click_y_pct: Math.round((e.offsetY / el.offsetHeight) * 100)
                    });
                });
            });
        });
    }

    // ---- SCROLL DEPTH TRACKING ----
    function initScrollTracking() {
        const thresholds = [25, 50, 75, 100];
        const fired = {};

        function checkScroll() {
            const scrollPct = Math.round(
                (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100
            );

            thresholds.forEach(function (t) {
                if (scrollPct >= t && !fired[t]) {
                    fired[t] = true;
                    sendGA4Event('scroll_depth', {
                        page_path: window.location.pathname,
                        percent_scrolled: t,
                        page_type: getPageType()
                    });
                }
            });
        }

        let ticking = false;
        window.addEventListener('scroll', function () {
            if (!ticking) {
                requestAnimationFrame(function () {
                    checkScroll();
                    ticking = false;
                });
                ticking = true;
            }
        });
    }

    // ---- ELEMENT VISIBILITY TRACKING ----
    function initVisibilityTracking() {
        if (!('IntersectionObserver' in window)) return;

        const observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    const zone = entry.target.getAttribute('data-track-zone');
                    if (zone) {
                        sendGA4Event('zone_view', {
                            page_path: window.location.pathname,
                            zone_name: zone,
                            page_type: getPageType()
                        });
                        observer.unobserve(entry.target);
                    }
                }
            });
        }, { threshold: 0.5 });

        // Auto-tag zones
        const pageType = getPageType();
        const zones = ZONE_MAP[pageType];
        if (!zones) return;

        zones.forEach(function (zoneDef) {
            document.querySelectorAll(zoneDef.selector).forEach(function (el) {
                el.setAttribute('data-track-zone', zoneDef.zone);
                observer.observe(el);
            });
        });
    }

    // ---- PAGE TIMING ----
    function initTimingTracking() {
        const startTime = Date.now();

        window.addEventListener('beforeunload', function () {
            const timeOnPage = Math.round((Date.now() - startTime) / 1000);
            sendGA4Event('page_time', {
                page_path: window.location.pathname,
                time_seconds: timeOnPage,
                page_type: getPageType()
            });
        });
    }

    // ---- INIT ----
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initZoneTracking();
            initScrollTracking();
            initVisibilityTracking();
            initTimingTracking();
        });
    } else {
        initZoneTracking();
        initScrollTracking();
        initVisibilityTracking();
        initTimingTracking();
    }
})();